var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailOpen = function SvgMailOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m4 8 9 7h6l9-7M15.118 3.271 3.706 6.783A1 1 0 0 0 3 7.739V23a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V7.739a1 1 0 0 0-.706-.956L16.882 3.27a3 3 0 0 0-1.764 0"
  })));
};
export default SvgMailOpen;